import EmployeeEmploymentInfoComponents from "../components/EmployeeEmploymentInfo";
import useEmployeeEmploymentInfo from "../hooks/useEmployeeEmploymentInfo";

function EmployeeEmploymentInfo() {
  const employeeEmploymentInfoProps = useEmployeeEmploymentInfo();
  return <EmployeeEmploymentInfoComponents {...employeeEmploymentInfoProps} />;
}

export default EmployeeEmploymentInfo;
